module.exports = __webpack_public_path__ + "static/media/upload.565a73db.svg";